export class PasswordRule {
    /**
     * Class that defines the structure of a application
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-03-06
     */
    idRule: number;
    name: string;
    textRule: string;
    regex: RegExp;
    value: boolean;
}

export class UserEmail {    
    
    email: string;   
}

